import { PureComponent } from 'react'
import { Layout } from 'antd'
// import { t } from "@lingui/macro"
// import { Trans } from "@lingui/macro"
import ScrollBar from './ScrollBar'
import { config } from 'utils'
import SiderMenu from './Menu'
import styles from './Sider.module.scss'
import { Link } from 'components'
import  Logo  from "client/assets/images/logo.png";
import moment from 'moment'
import { APP_LOCAL_DATE_FORMAT_INSURANCE } from 'config/constants'
import { DoctorProfileSetting } from 'config/routersConstants'
import { loadProfileImage } from 'utils/CreateProfileFromInitials'
import { capitalize } from 'lodash'

class Sider extends PureComponent<any> {
  render() {
    const {
      menus,
      theme,
      isMobile,
      collapsed,
      // onThemeChange,
      onCollapseChange,
      isAuthenticated,
      publicLayout,
      account,
      onChangeCurrentMenu,
      setCurrentFlg,
      currentMenus
    } = this.props
    return (
      <Layout.Sider
        width={256}
        theme={theme}
        breakpoint="lg"
        trigger={null}
        collapsible
        collapsed={collapsed}
        style={{ 
          overflow: 'auto',
          height: '100vh',
          left: 0,
      }}
        //onBreakpoint={onCollapseChange}
        className={styles.sider}
      >
        {!isMobile && <div className={styles.brand}>
          {!collapsed  ?
           <Link to="/"> <img src={Logo} className="img-fluid logo_menu" alt="Logo" /></Link>
            :
            <img alt="logo" src={config.logoIconPath} />
            }
        </div>}

        <div className={styles.menuContainer}>
          <ScrollBar
            options={{
              // Disabled horizontal scrolling, https://github.com/utatti/perfect-scrollbar#options
              suppressScrollX: true,
            }}
          >
            {/* <div className="widget-profile"> */}

            {isAuthenticated && /**#616 - @author Liya -@Date - 24-09-2021  */
				<div className="profile-info-widget">
					{/*
						* Bug/CR # 458
						* @Author Akhil MC
						* @Date 28 June 2021
					*/}
          {/* <div className="media"> */}
          {/* <div>
          {isPatient(account) &&
                  <FamilyMemberGroup/>}
          </div> */}
					<a href={ DoctorProfileSetting.path} className={collapsed?"booking-doc-img-collapsed":"booking-doc-img"}>
						<img src={loadProfileImage(account.userProfileImage, account.firstName+" "+account.lastName,account.color)} alt="User" />
					</a>       
					<div className="profile-det-info ">

          {!collapsed &&
            <div className="patient-details">
							{/**
								 * Bug #498
								 * @Author Jithin Kuriakose
								 * @Date 13 July 2021
								 */
							}
							<h3>{(account?.firstName || account?.lastName) ? capitalize(account?.firstName) + " " +  capitalize(account?.lastName) : ""}</h3>
              {(account?.dateOfBirth) && (<h5><i className="fas fa-birthday-cake"></i> {moment(account.dateOfBirth, 'YYYY-MM-DD').locale('en').
              format(APP_LOCAL_DATE_FORMAT_INSURANCE) +
               ", " + moment().diff(moment(account.dateOfBirth).format("YYYY-MM-DD"), 'years', false) + " years"}</h5>)}
							{/* {(account?.state || account?.country) && (<h5 className="mb-0"><i className="fas fa-map-marker-alt"></i> {account?.state + ", " + account?.country}</h5>)} */}
              {/**End Bug #498**/}
              
            </div>
          }
					</div>
				{/* </div> */}
			</div>
      }
            <SiderMenu
              menus={menus}
              theme={theme}
              isMobile={isMobile}
              collapsed={collapsed}
              onCollapseChange={onCollapseChange}
              isAuthenticated={isAuthenticated}
              publicLayout={publicLayout}
              account={account}
              onChangeCurrentMenu={onChangeCurrentMenu}
              currentMenus={currentMenus}
              setCurrentFlg={setCurrentFlg}
            />
          </ScrollBar>
        </div>
        {/* {!collapsed && (
          <div className={styles.switchTheme}>
            <span>
              <BulbOutlined />
              <Trans>Switch Theme</Trans>
            </span>
            <Switch
              onChange={onThemeChange.bind(
                this,
                theme === 'dark' ? 'light' : 'dark'
              )}
              defaultChecked={theme === 'dark'}
              checkedChildren={t`Dark`}
              unCheckedChildren={t`Light`}
            />
          </div>
        )} */}
      </Layout.Sider>
    )
  }
}


export default Sider
